import React from "react";

export default function PanchashilaFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-pan11{fill:#e21d27}.cls-pan12{fill:#eae4e4}"}</style>
        </defs>
        <path
          d="M1793.02 173.28H381.52a3.21 3.21 0 0 0-3.19 3.52c.09.86.51 1.65 1.19 2.19 13.23 10.59 26.62 21.13 39.97 31.77h1336.05c-2.2 468.86-4.41 937.72-6.61 1406.58 14.69-5.7 29.39-11.4 44.08-17.11V173.28Z"
          className="cls-pan11"
        />
        <path
          d="M1774.28 1608.47c-526.47 185.61-944.21 248.28-1115.04 205.26-164.15-41.34-236.57-137.42-236.57-137.42-31.18-41.37-46.19-82.97-53.92-111.33 28.07 13.38 71.13 32.44 125.24 50.45 277.42 92.28 522.63 49.23 747.98 6.96 133.86-25.11 319.4-70.85 532.32-160.03v146.12Z"
          className="cls-pan12"
        />
        <path
          d="M1774.28 1464.09c-45.38 17.4-771.81 292.15-1118.52 241.79-74.03-10.75-215.95-31.37-287.01-140.9-25.71-39.63-34.64-79.33-38.27-104.37a653.685 653.685 0 0 0 72.63 42.51c140.44 70.46 328.75 100.85 838.85-25.11 138.93-34.31 321.28-85.04 532.32-160.03v146.12Z"
          className="cls-pan11"
        />
        <path
          d="M330.48 1460.61c-72.79-100.07-82.32-177.87-79.37-227.87 9.28-157.24 153.72-237.57 136.77-394.29-5.42-50.11-25.24-88.61-38.27-110.17 80.65 47.85 107.93 97.99 118.28 133.94 37.36 129.7-99.24 231.31-131.73 481.49-6.66 51.3-6.46 93.18-5.69 116.89Z"
          className="cls-pan11"
        />
        <path
          d="M344.59 727.2c-112.62-70.62-138.15-128.79-137.6-171.13 1.42-109.53 186.1-167.93 186.11-308.75 0-30.6-8.66-55.2-14.63-69.18 16.92 21.34 40.64 57.66 45.31 105.13 13.87 141.15-155.45 227.43-131.73 354.5 7.23 38.74 30.33 68.35 52.54 89.42Z"
          className="cls-pan12"
        />
        <path
          d="M350.19 732.97c-72.79-73.68-82.32-130.96-79.37-167.77 9.1-113.45 138.91-166.74 136.77-290.3-.73-42.18-16.88-76.08-29.13-96.76 79.58 41 102.57 83.5 109.14 114.26 20.72 97.05-98.91 168.42-131.73 354.5-6.66 37.77-6.46 68.61-5.69 86.06Z"
          className="cls-pan11"
        />
        {children}
      </g>
    </svg>
  );
}
